
export const registerUser = () => {
    return {
        type: "REGISTER_USER",
    }
}

export const registerSuccess = user => {
    return {
        type: "REGISTER_SUCCESS",
        payload: user,
    }
}
